import React, {
    useState, useRef, useLayoutEffect, useCallback
} from 'react';
import ReactDOM from 'react-dom';
import useEventListener from '../../common/hooks/useEventListener';

const withScrollbarMeasure = (Component) => (props) => {
    const reactTableRef = useRef(null);
    const tbody = useRef(null);
    const theads = useRef(null);
    const [shouldScroll, setShouldScroll] = useState(false);

    const getReactTableRef = useCallback((ref) => { reactTableRef.current = ref; }, []);

    const measureScroll = useCallback(() => {
        if (!reactTableRef.current) return;
        // eslint-disable-next-line
        tbody.current = ReactDOM.findDOMNode(reactTableRef.current).getElementsByClassName('rt-tbody')[0];

        // eslint-disable-next-line react/no-find-dom-node
        theads.current = [...ReactDOM.findDOMNode(reactTableRef.current).getElementsByClassName('rt-thead')];

        // eslint-disable-next-line react/no-find-dom-node
        theads.current.forEach((thead) => {
            tbody.current.addEventListener('scroll', () => {
                // eslint-disable-next-line no-param-reassign
                thead.scrollLeft = tbody.current.scrollLeft;
            });
        });
        const newShouldScroll = tbody.current && (tbody.current.scrollHeight > tbody.current.clientHeight);
        if (shouldScroll !== newShouldScroll) {
            setShouldScroll(newShouldScroll);
        }
    }, [
        shouldScroll
    ]);

    useLayoutEffect(measureScroll);
    useEventListener('resize', measureScroll);

    return (
        <Component
            { ...props }
            getReactTableRef={ getReactTableRef }
            shouldShowScrollbar={ shouldScroll }
        />
    );
};

export default withScrollbarMeasure;
